export default __webpack_public_path__ + "static/media/Group95.afe5419f.png";